export default require('../otherChains/bob').default.rpcUrls.default.http[0]